export const MAITRE_INTRO_KEY = 'aleno_maitre_intro_v1';
export const MAITRE_INTRO_EVENT = 'aleno:maitre-intro';

export function hasSeenMaitreIntro(): boolean {
  try {
    return window.localStorage.getItem(MAITRE_INTRO_KEY) === '1';
  } catch {
    return false;
  }
}

export function markMaitreIntroSeen(): void {
  try {
    window.localStorage.setItem(MAITRE_INTRO_KEY, '1');
  } catch {
    /* private mode / blocked storage */
  }
}

export function requestMaitreIntro(): void {
  window.dispatchEvent(new Event(MAITRE_INTRO_EVENT));
}
